import { FC } from 'react';
import { ExcelImportResult } from '../../models/fees';
import { ImportDialog, ExcelData, ExcelRow } from './ImportDialog';

interface ImportHudLinesDialogProps {
  visible: boolean;
  onClose: () => void;
  onImport: (file: File) => Promise<ExcelImportResult>;
}

interface HudLinePreview {
  hudLines: Set<string>;
  totalRows: number;
  vendors: Set<string>;
}

export const ImportHudLinesDialog: FC<ImportHudLinesDialogProps> = ({
  visible,
  onClose,
  onImport,
}) => {
  return (
    <ImportDialog<HudLinePreview>
      visible={visible}
      onClose={onClose}
      onImport={onImport}
      title="Import HUD Lines"
      entityName="HUD lines"
      parsePreview={(dataRows: ExcelData) => {
        const hudLines = new Set<string>();
        const vendors = new Set<string>();

        dataRows.forEach((row: ExcelRow) => {
          if (row[0]) vendors.add(String(row[0]).trim());
          if (row[1]) hudLines.add(String(row[1]).trim());
        });

        return {
          hudLines,
          totalRows: dataRows.length,
          vendors,
        };
      }}
      renderPreview={(preview: HudLinePreview, fileName: string) => (
        <div className="surface-100 p-3 border-round">
          <h4 className="mt-0 mb-3">Import Preview</h4>
          <div className="flex flex-column gap-3">
            <div className="flex justify-content-between">
              <span className="font-semibold">File:</span>
              <span>{fileName}</span>
            </div>
            <div className="flex justify-content-between">
              <span className="font-semibold">Total HUD Lines:</span>
              <span className="text-xl text-blue-600 font-bold">{preview.totalRows}</span>
            </div>
          </div>
        </div>
      )}
    />
  );
};
